module.exports = __webpack_public_path__ + "img/1.acadab08.png";